import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import styled from "styled-components";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import Select from 'react-select';
import ClaimInfoUpdateModal from "../../../../modal/PC/quality/ClaimInfoUpdateModal";
import { ResponsiveContainer, ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import Moment from 'moment';
import "moment/locale/ko";
import { useNavigate, useLocation } from "react-router-dom";

const ClaimInfo = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('클레임 정보'); // 기본값 강제 지정
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [gridWidth, setGridWidth] = useState('520px');
    
    const [graphData, setGraphData] = useState([]);
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    
    const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectID, setSelectID] = useState('');
    const [keyword, setKeyword] = useState({ yyyy: Moment().format("YYYY") });
    const [yyyyOption, setYYYYOption] = useState([]);

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        const currentPath = String(window.location.pathname).toLowerCase().split("/").slice(0, 3).join("/");

        if (Array.isArray(accessList)) {
            // DB의 URL(/p/claim)과 실제 접속 URL(/p/claim_info)이 달라서 발생하는 엉뚱한 매칭 방지
            const matchedMenu = accessList.find(item => {
                const dbUrl = String(item.menu_url).toLowerCase();
                return dbUrl === currentPath || (currentPath === '/p/claim_info' && dbUrl === '/p/claim');
            });
            
            if (matchedMenu) {
                setMenuID(matchedMenu.menu_id);
                setMenuName(matchedMenu.menu_name);
                setMenuUpdateExistYN(matchedMenu.menu_update_exist_yn);
                setMenuDeleteExistYN(matchedMenu.menu_delete_exist_yn);
                setMenuUpdateYN(matchedMenu.menu_update_yn);
                setMenuDeleteYN(matchedMenu.menu_delete_yn);
                return; 
            }
        }
        
        Swal.fire({
            title: '<p style="color:red">접근 권한 오류</p>',
            text: '화면에 접근 권한이 없습니다.',
            confirmButtonText: '확인',
            confirmButtonColor: '#7066e0',
            timer: 5000,
            timerProgressBar: true
        }).then(() => {
            return navigate(-1);
        });
    }, []);

    useEffect(() => { 
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView(); 
        }
    }, [keyword.yyyy]);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleInitSelect();
            handleView();
        }
    }, [MenuID]);

    const handleInitSelect = () => {
        let yearOptions = [];
        for (let y = 2025; y <= 2099; y++) yearOptions.push({ value: String(y), label: String(y) });
        setYYYYOption(yearOptions);

        setColumns([
            // 1. 수정 컬럼 단독 분리
            {
                field: 'updated', headerName: '수정', width: 55, type:'actions', disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem 
                        icon={<EditIcon color={MenuUpdateYN === "Y" ? "primary" : "grey"} />} 
                        onClick={() => UpdateClick(params)} 
                        label="Edit" 
                        disabled={MenuUpdateYN !== "Y"} 
                    />
                ], headerAlign: 'center', align:'center'
            },
            // 2. 삭제 컬럼 단독 분리
            {
                field: 'deleted', headerName: '삭제', width: 55, type:'actions', disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem 
                        icon={<DeleteIcon color={MenuDeleteYN === "Y" ? "error" : "grey"} />} 
                        onClick={() => DeleteClick(params)} 
                        label="Delete" 
                        disabled={MenuDeleteYN !== "Y"} 
                    />
                ], headerAlign: 'center', align:'center'
            },
            { field: 'claim_id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'claim_date', headerName: '클레임일자', width: 110, headerAlign: 'center', align:'center'},
            { field: 'claim_title', headerName: '제목', flex: 1, minWidth: 200, headerAlign: 'center', align:'left' }
        ]);
    };

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        claim_id: false,
        updated: true,
        deleted: true, // 삭제 컬럼 활성화
        claim_date: true,
        claim_title: true
    });

    const handleInit = () => setKeyword({ yyyy: Moment().format("YYYY") });

    const handleReg = () => {
        setSelectID('');
        setModalTitle('클레임 등록');
        setUpdateModalOpen(true);
    };

    const UpdateClick = (object) => {
        setSelectID(object.row.claim_id);
        setModalTitle('클레임 수정');
        setUpdateModalOpen(true);
    };

    const DeleteClick = (object) => {
        Swal.fire({
            title: '삭제 확인',
            html: '선택한 클레임을 <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton: true,
            confirmButtonColor: "#d33",
            confirmButtonText: "삭제",
            cancelButtonText: "닫기"
        }).then((result) => {
            if (result.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);

                axios.post('/api/p/ClaimInfo/Delete', new URLSearchParams({ delete_claim_id: object.row.claim_id }), { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){
                        Swal.fire({
                            title: '삭제 완료',
                            text: '정상적으로 삭제 되었습니다.',
                            confirmButtonText: '확인',
                            timer: 5000,
                            timerProgressBar: true
                        }).then(() => handleView());
                    } else {
                        appStore.capture();
                    }
                })
                .catch(function (error) {
                    appStore.capture();
                })
                .finally(() => appStore.setLoading(false));
            }
        });
    };

    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/ClaimInfo/List', { params : { yyyy : keyword.yyyy }, withCredentials: true })
        .then((response) => { 
            const data = response.data;

            const uniqueRows = data.filter((item, index) =>
                data.findIndex(d => String(d.claim_id) === String(item.claim_id)) === index
            );

            setRows(uniqueRows);
            setOriginRows(data);

            let monthlyCounts = {};
            for(let i=1; i<=12; i++) monthlyCounts[`${keyword.yyyy}-${String(i).padStart(2, '0')}`] = 0;
            
            uniqueRows.forEach(item => { 
                if(item.claim_date && item.claim_date.length >= 7){
                    let month = item.claim_date.substring(0, 7);
                    if(monthlyCounts[month] !== undefined) monthlyCounts[month]++;
                }
            });

            let graph_array = Object.keys(monthlyCounts).map(key => ({
                name: key, '발생건수': monthlyCounts[key]
            }));
            setGraphData(graph_array);
        })
        .catch((error) => appStore.capture())
        .finally(() => appStore.setLoading(false));
    };

    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox" style={ { height: '140px', boxShadow: 'none' } }>
                <div className="menu-action" style={ { height: '55px' } }>
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                        {MenuUpdateYN === "Y" && 
                        <Button 
                            onClick={handleReg} 
                            variant="outlined" 
                            className="btn-p btn-u" 
                            sx={{ m: 1, fontSize: 15, color: "white", borderColor: "#FF3636", backgroundColor: "#FF3636", ":hover": { boxShadow: "2px 2px 2px #FF3636", backgroundColor: "#FF3636", borderColor: "#FF3636" } }}>
                            등록
                        </Button>}
                        <Button 
                            onClick={handleInit} 
                            variant="outlined" 
                            className="btn-p" 
                            sx={{ m: 1, fontSize: 15, color: "white", borderColor: "black", backgroundColor: "black", ":hover": { boxShadow: "2px 2px 2px black", backgroundColor: "black", borderColor: "black" } }}>
                            초기화
                        </Button>
                        <Button 
                            onClick={handleView} 
                            variant="outlined" 
                            className="btn-p" 
                            sx={{ m: 1, fontSize: 15, color: "white", borderColor: "#3D63AE", backgroundColor: "#3D63AE", ":hover": { boxShadow: "2px 2px 2px #3D63AE", backgroundColor: "#3D63AE", borderColor: "#3D63AE" } }}>
                            조회
                        </Button>
                    </div>
                </div>
                <div className="menu-keyword" style={ { paddingTop:'5px' } }>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title" style={{ width: '80px', paddingTop: '7px', fontWeight: 'bold' }}>
                            년도
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="년도" onChange={(e) => setKeyword({...keyword, yyyy: e.value})} value={yyyyOption.filter(opt => opt.value === keyword.yyyy)} options={yyyyOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                </div>
            </div>
            
            <div style={ { width: '100%' } }>
                <div className="grid" style={ { top: '142px', float: 'left', width: gridWidth } }>
                    <div style={{ float: 'left', width: '100%' }}>
                        <div className="grid_sub" style={ { width: '100%', height: 'calc(100vh - 242px)', fontSize: '17px'} }>
                            <DataGrid 
                                className="grid_main" 
                                rows={rows} 
                                columns={columns} 
                                columnVisibilityModel={columnVisibilityModel}
                                getRowId={(row) => row.claim_id} 
                                slots={{ noRowsOverlay: GridNoRow }} 
                                AlternatingRowBackground="LavenderBlush"
                                rowsPerPageOptions={[20, 50, 100]}
                            />
                        </div>
                    </div>
                </div>
                
                <div className="grid" style={ { top: '188px', float: 'right', width: `calc(100% - ${gridWidth})`, position: 'relative', overflowY: 'hidden' } }>
                    <div style={{ float: 'right', width: '100%', paddingRight:'50px'}}>
                        <div style={{ width: '100%', height: 'calc(100vh - 350px)' }}>
                            <ResponsiveContainer width="100%" height="100%">
                                <ComposedChart data={graphData} margin={{ top: 5, right: 5, bottom: 0, left: 50 }}>
                                    <CartesianGrid stroke="#f5f5f5" />
                                    <XAxis dataKey="name" />
                                    <YAxis allowDecimals={false} tickFormatter={tick => { return tick.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }} />
                                    <Tooltip formatter={(value) => new Intl.NumberFormat('ko').format(value)} />
                                    <Legend />
                                    <Bar dataKey="발생건수" barSize={20} fill="#8884d8" />
                                </ComposedChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                    {isUpdateModalOpen && (
                        <ClaimInfoUpdateModal
                            onClose={() => setUpdateModalOpen(false)}
                            title={modalTitle}
                            id={selectID}
                            originData={originRows.find(row => String(row.claim_id) === String(selectID))}
                            originRows={originRows.filter(row => String(row.claim_id) === String(selectID))}
                            MenuUpdateYN={MenuUpdateYN}
                            handleView={handleView}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;
export default ClaimInfo;